const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMegaphoneAdvertisingSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D7D5D9"
    },
    points: "80.917,252.703 163.97,252.703 211.115,512 80.917,512 80.917,312.321 "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.14
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3E3B43"
    },
    points: "163.97,252.703 80.917,252.703 80.917,286.34 169.846,285.021  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7D5D9"
    },
    d: "M96.764,137.031H74.277c-32.63,0-59.327,26.697-59.327,59.327v8.072 c0,32.63,26.697,59.327,59.327,59.327h90.984c20.143,0,39.677,6.895,55.357,19.539L366.13,400.631V0L220.423,117.493 c-15.68,12.643-35.215,19.539-55.357,19.539H142.74H96.764z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.133,
    style: {
      fill: "#57545C"
    },
    width: 61.116,
    height: 400.635
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7D5D9"
    },
    d: "M464.034,140.978c17.421,12.868,33.016,34.285,33.016,59.337c0,38.554-31.254,69.808-69.808,69.808 V130.507C427.243,130.507,449.859,130.507,464.034,140.978z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.31,
      fill: "#3E3B43",
      enableBackground: "new"
    },
    d: "M427.243,240.869v29.253 c38.554,0,69.808-31.254,69.808-69.808c0-4.856-0.591-9.573-1.663-14.121C488.471,217.469,460.598,240.869,427.243,240.869z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#52A2E7"
    },
    points: "368.168,0 280.958,70.323 280.958,330.308 368.168,400.63 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.36,
      fill: "#3E3B43",
      enableBackground: "new"
    },
    d: "M221.171,228.22c-15.68-12.643-35.215-19.539-55.357-19.539 H74.83c-24.291,0-45.286-14.801-54.434-35.825c-3.14,7.217-4.893,15.164-4.893,23.502v8.072c0,32.63,26.697,59.327,59.327,59.327 h90.984c20.143,0,39.677,6.895,55.357,19.539l145.511,117.335h61.114v-55.074h-61.114L221.171,228.22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7D5D9"
    },
    d: "M187.791,387.879c0,0,66.588-13.089,73.29-72.398l-26.383-20.832 c-5.06,44.78-54.422,55.394-54.422,55.394L187.791,387.879z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.31
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E3B43"
    },
    d: "M261.063,316.096l-26.365-21.448c-1.073,9.492-4.088,17.39-8.166,23.951l27.632,22.068 C257.556,333.54,260.012,325.395,261.063,316.096z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.36
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3E3B43"
    },
    points: "172.82,301.382 80.161,407.842 80.161,512 188.52,387.728  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphoneAdvertisingSvgrepoCom);
export default __webpack_public_path__ + "static/media/megaphone-advertising-svgrepo-com.de8ad62da3d018b718d88eb32670ab33.svg";
export { ForwardRef as ReactComponent };